export default {
  filterWeek: { id: 'filter_week' },
  mapSettings: { id: 'map_settings' },
  chooseVariant: { id: 'choose_variant' },
  chooseSiteType: { id: 'choose_site_type' },
  chooseDataType: { id: 'choose_data_type' },
  mapFilterHint: { id: 'map_filter_hint' },
  got_it: { id: 'got_it' },
  cancel: { id: 'back' },
  seip: { id: 'seip' },
  location: { id: 'location' },
  mortality: { id: 'mortality' },
  siteInfo: { id: 'site_info' },
  site_list: { id: 'sites' },
  cage_list: { id: 'cage_list' },
  locus: { id: 'locus' },
  createEvent: { id: 'create_event' },
  dateRange: { id: 'date_range' },
}
